/** GA4-only currency rounding — always 2 decimal places; does not affect PDP/cart display. */
export const roundGa4Currency = (value) => {
  const n = Number(value);

  return Number.isFinite(n) ? n.toFixed(2) : null;
};
